import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { usePortalAuth } from '../../contexts/PortalAuthContext';
import PortalAuthService from '../../services/PortalAuthService';

export default function PortalAuthGuard({ children }) {
    const token = localStorage.getItem('PORTAL_TOKEN');
    const { setClientLogoBase64, setClientName, setCustomerName, setMemberships } = usePortalAuth();

    useEffect(() => {
        if (!token) return;
        PortalAuthService.me()
            .then(data => {
                if (data.clientLogoBase64 !== undefined) {
                    const logo = data.clientLogoBase64 || null;
                    if (logo) localStorage.setItem('PORTAL_CLIENT_LOGO', logo);
                    else localStorage.removeItem('PORTAL_CLIENT_LOGO');
                    if (setClientLogoBase64) setClientLogoBase64(logo);
                }
                if (data.clientName && setClientName) setClientName(data.clientName);
                if (data.customerName && setCustomerName) setCustomerName(data.customerName);
                // Keeps the switcher in sync for sessions opened before it existed,
                // and reflects memberships granted/revoked since login.
                if (setMemberships) setMemberships(data.memberships || []);
            })
            .catch(() => {});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!token) return <Navigate to="/portal/login" replace />;
    return children;
}
